import { CommonModule } from '@angular/common';
import { Component, EventEmitter, OnInit, Output, Injector } from '@angular/core';
import { Mtrki01Component } from './mtrki01Pkg.component';
import { Mtrki01DetailComponent } from './mtrki01-detailPkg.component';
import { MaterialModule } from 'jk-service';
import { JkBillFormComponent } from 'jk-advcom';
import { JackBaseComponentModule } from 'jk-service';

@Component({
  selector: 'app-mtrki01-bill',
  standalone: true,
  imports: [CommonModule,
    MaterialModule,
    JackBaseComponentModule,
    Mtrki01Component,
    Mtrki01DetailComponent,
  ],
  templateUrl: './mtrki01BillPkg.component.html',
  styleUrls: [],
})
export class Mtrki01BillComponent extends JkBillFormComponent implements OnInit {
  override _programId = 'mtrki01'; //###
  override masterPage!: Mtrki01Component;
  //override detailPage!:  Mtrki01DetailComponent;
  constructor() {
    super();
    this.setFormOpt2(); //###
  }

  override ngOnInit() {
    super.ngOnInit();
  }
  override async ngAfterViewInit() {
    super.ngAfterViewInit();
  }
  override doMasterPageReady($event: any) {
    super.doMasterPageReady($event);
  }
  // 以下客製 --------------------------------------------------------
  get wd015List() {
    if (this.masterPage && this.masterPage.srv && this.masterPage.srv.mtrWd015List)
      return this.masterPage.srv.mtrWd015List
    else
      return [];
  }
  get wd015Index() {
    if (this.masterPage && this.masterPage.srv)
      return this.masterPage.srv.wd015Index
    else
      return 0;
  }
  set wd015Index(value: number) {
    if (this.masterPage && this.masterPage.srv)
      this.masterPage.srv.wd015Index = value;
  }

}
